import React from 'react';


export default function PrivacyPolicy() {
    return <>
        <p><i>Last updated: (Thursday, 13 February 2020)</i></p>
        <ol type="A">
            <li>What information Portacode collects
                <p>
                    Portacode collects information from your GitHub account by your consent for your registration, payment, transactions, and user profile. We also automatically collect from you your usage information, cookies and similar technologies, and device information, subject, where necessary, to your consent. We only collect the minimum amount of personal information necessary from you, unless you choose to provide more.
                </p>
            </li>
            <li>What information Portacode does not collect
                <p>
                    We don’t knowingly collect information from children under 13, we don’t collect Sensitive Personal Information, and we do not collect information from your repositories.
                </p>
            </li>
            <li>How Portacode uses your information
                <p>
                    Portacode uses your information to provide you the Service, to communicate with you, for security purposes, and to improve our Service.
                </p>
            </li>
            <li>How we share the information we collect
                <p>
                    We do not share your information with any third parties.
                </p>
            </li>
            <li>Our use of cookies and tracking
                <p>
                    Portacode uses cookies to make interactions with our service easy and meaningful. Cookies are small text files that websites often store on computer hard drives or mobile devices of visitors. We use cookies (and similar technologies, like HTML5 localStorage) to keep you logged in, remember your preferences, and provide information for future development of Portacode. For security purposes, we use cookies to identify a device. By using our Website, you agree that we can place these types of cookies on your computer or device. If you disable your browser or device’s ability to accept these cookies, you will not be able to log in or use our services.
                </p>
            </li>
            <li>How Portacode secures your information
                <p>
                    Portacode takes all measures reasonably necessary to protect User Information from unauthorized access, alteration, or destruction; maintain data accuracy; and help ensure the appropriate use of User Personal Information. Transmission of data on Portacode is encrypted using SSL, HTTPS, and git repository content is encrypted on GitHub.
                </p>
            </li>
            <li>Changes to our Privacy Statement
                <p>
                    We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
                </p>
            </li>
            <li>Contacting Portacode
                <p>
                    If you have concerns about the way Portacode is handling your personal information or if you have any questions regarding Portacode's Privacy Statement or information practices, please let us know by contacting us at <a href="mailto:privacy@portacode.com">privacy@portacode.com</a>
                </p>
            </li>
        </ol>
    </>
} 